import { render, staticRenderFns } from "./PhotoSliderDialog.vue?vue&type=template&id=fe2be622&scoped=true"
import script from "./PhotoSliderDialog.vue?vue&type=script&lang=js"
export * from "./PhotoSliderDialog.vue?vue&type=script&lang=js"
import style0 from "./PhotoSliderDialog.vue?vue&type=style&index=0&id=fe2be622&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe2be622",
  null
  
)

export default component.exports